var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 46,
    viewBox: "0 0 64 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 0H1C0.446667 0 0 0.446667 0 1V35C0 35.5533 0.446667 36 1 36H28V37.1067C28 38.4667 27.0867 39.6533 25.7733 40.0067L10.74 44.0333C10.2067 44.1733 9.88667 44.7267 10.0333 45.26C10.1733 45.7933 10.7267 46.1133 11.26 45.9667L27.6667 41.5667C30.5067 40.8067 33.5 40.8067 36.34 41.5667L52.7467 45.96C53.28 46.1 53.8267 45.7867 53.9733 45.2533C54.1133 44.72 53.8 44.1733 53.2667 44.0267L38.2267 40C36.92 39.6467 36.0067 38.46 36 37.1V35.9933H63C63.5533 35.9933 64 35.5467 64 34.9933V1C64 0.446667 63.5467 0 63 0ZM29.56 39.16C29.8533 38.5133 30 37.8133 30 37.1067V36H34V37.1067C34 37.8133 34.1533 38.5133 34.44 39.16C32.82 38.9467 31.18 38.9467 29.5533 39.16H29.56ZM62 34H2V2H62V34Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/TV.8b5b3fa1235b705110599a40c581e1a4.svg";
export { ForwardRef as ReactComponent };